var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    {
      staticClass: "px-3",
      on: {
        click: function($event) {
          return _vm.navigate()
        }
      }
    },
    [
      _c(
        "v-list-item-icon",
        [_c("v-icon", { attrs: { large: "" } }, [_vm._v(_vm._s(_vm.icon))])],
        1
      ),
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", { staticClass: "subtitle-1" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }